<template>
    <div class="">
        <div class="top-bar-color"></div>

        <div class="bg-yellow-400 w-full p-6 text-left" v-if="showVerifiedWarningBanner">
            <span class="font-bold"><font-awesome-icon
                :icon="['fas', 'exclamation-triangle']"
                class="text-l mr-2"
            ></font-awesome-icon>Required Action: Complete A2P Application</span><br/>
            Click here to submit your wireless carrier registration application. This is required in order to send messages.
            <br/>
            <Link href="/verified/start" class=""><span class="inline-block mt-4 font-bold hover:underline px-4 py-2 bg-black text-white rounded">Start Application</span></Link>
        </div>
        <div class="bg-yellow-400 w-full p-6 text-left" v-if="$page.props.auth.user && $page.props.auth.user.organization.suspended">
          <span class="font-bold"><font-awesome-icon
            :icon="['fas', 'exclamation-triangle']"
            class="text-l mr-2"
          ></font-awesome-icon>Account Suspended</span><br/>
            Your account has been suspended. Please contact support for more information.
          <br/>
        <button class="" @click="showIntercom"><span class="inline-block mt-4 font-bold hover:underline px-4 py-2 bg-black text-white rounded">Contact Support</span></button>
      </div>

      <div class="bg-yellow-400 w-full p-6 text-left" v-if="showAccountPausedWarning">
          <span class="font-bold"><font-awesome-icon
            :icon="['fas', 'exclamation-triangle']"
            class="text-l mr-2"
          ></font-awesome-icon>Account Paused</span><br/>
            Your account is paused. Upgrade to a plan to start sending messages again.
          <br/>
          <Link :href="route('subscriptions.index')" class=""><span class="inline-block mt-4 font-bold hover:underline px-4 py-2 bg-black text-white rounded">Select a Plan</span></Link>
      </div>

        <div class="min-h-screen bg-gray-100 flex">
            <div
                class="min-h-screen w-64 bg-white border-r border-gray-100 hidden sm:block pt-16"
            >
                <jet-nav-link
                    class="font-bold"
                    href="/dashboard"
                    :active="route().current() == 'dashboard'"
                >
                    <font-awesome-icon
                        :icon="['far', 'comment']"
                        class="text-xl mr-2"
                    ></font-awesome-icon>
                    Dashboard
                </jet-nav-link>
                <div class="px-4 py-2 bg-gray-200">
                    <p class="font-bold text-gray-700">Messages</p>
                </div>
                <jet-nav-link href="/messages/inbox" :active="route().current() == 'messages.inbox'">
                    <inbox-icon />
                    Inbox
                </jet-nav-link>
                <jet-nav-link
                    href="/messages/scheduled"
                    :active="route().current() == 'md.scheduled'"
                >
                    <font-awesome-icon
                        :icon="['far', 'calendar-days']"
                        class="text-xl mr-2"
                    ></font-awesome-icon>
                    Scheduled
                </jet-nav-link>
                <jet-nav-link
                  href="/autoresponder"
                  :active="route().current() == 'autoresponder.index'"
                >
                  <font-awesome-icon
                    :icon="['far', 'message-bot']"
                    class="text-xl mr-2"
                  ></font-awesome-icon>
                  Autoresponders
                </jet-nav-link>
                <jet-nav-link
                    href="/messages/sent"
                    :active="route().current() == 'messages.sent'"
                >
                    <font-awesome-icon
                        :icon="['far', 'paper-plane']"
                        class="text-xl mr-2"
                    ></font-awesome-icon>
                    Sent
                </jet-nav-link>
              <jet-nav-link
                 href="/template"
                 :active="route().current() == 'template.index'"
               >
               <font-awesome-icon
                 :icon="['far', 'clipboard-list']"
                   class="text-xl mr-2"
                  ></font-awesome-icon>
                Templates
               </jet-nav-link>
                <div class="px-4 py-2 bg-gray-200">
                    <p class="font-bold text-gray-700">Recipients</p>
                </div>
                <jet-nav-link
                    href="/contacts"
                    :active="(route().current() == 'contacts.index') || (route().current() == 'contacts.view')
                    || (route().current() == 'contacts.edit.form')"
                    class=""
                >
                    <font-awesome-icon
                        :icon="['far', 'user-group']"
                        class="text-xl mr-2"
                    ></font-awesome-icon>
                    Contacts
                </jet-nav-link>
                <jet-nav-link
                    v-if="$page.props.is_admin"
                    href="/custom-fields"
                    :active="route().current() == 'custom-fields.index'"
                    class="flex items-center"
                    style=""
                >
                    <div class="flex items-center">
                        <svg 
                            class="w-4 h-4 mr-2 text-gray-400" 
                            viewBox="0 0 16 16"
                            fill="none"
                            stroke="currentColor"
                        >
                        <path d="M8 0v16" stroke-width="1.5"/>
                        </svg>
                        Custom Fields
                    </div>
                </jet-nav-link>
                <jet-nav-link
                    href="/groups"
                    :active="route().current() == 'groups.index'"
                >
                    <font-awesome-icon
                        :icon="['far', 'screen-users']"
                        class="text-xl mr-2"
                    ></font-awesome-icon>
                    Lists
                </jet-nav-link>

            <template v-if="$page.props.is_admin">
                <div class="px-4 py-2 bg-gray-200">
                    <p class="font-bold text-gray-700">Promote</p>
                </div>
                <jet-nav-link
                    href="/web-forms"
                    :active="$page.url.startsWith('/web-forms')"
                >
                    <font-awesome-icon
                        :icon="['far', 'rectangle-list']"
                        class="text-xl mr-2"
                    />
                    Forms
                </jet-nav-link>
                <jet-nav-link
                    href="/keywords"
                    :active="route().current() == 'keywords.index'"
                >
                    <font-awesome-icon
                      :icon="['far', 'key']"
                      class="text-xl mr-2"
                    />
                    Keywords
                </jet-nav-link>
            </template>

            <template v-if="$page.props.is_admin">
                <div class="px-4 py-2 bg-gray-200">
                    <p class="font-bold text-gray-700">Connect</p>
                </div>
                <jet-nav-link
                    href="/zapier-integration"
                    :active="$page.url.startsWith('/zapier-integration')"
                >
                    <font-awesome-icon
                    :icon="['far', 'puzzle-piece']"
                    class="text-xl mr-2"
                    ></font-awesome-icon>
                    Integrations
                </jet-nav-link>
                  <jet-nav-link

                    href="/zapier-tokens"
                    :active="$page.url.startsWith('/zapier-tokens')"
                  >
                    <font-awesome-icon
                      :icon="['far', 'lock']"
                      class="text-xl mr-2"
                    ></font-awesome-icon>
                    API Tokens
                </jet-nav-link>
            </template>

            </div>
            <!-- Primary Content Wrapper -->
            <div class="h-full w-full sticky top-0">
                <nav class="bg-white border-b border-gray-100 w-full sticky top-0 z-10">
                    <!-- Primary Navigation Menu -->
                    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div class="flex justify-between h-16">
                            <div class="flex">
                                <!-- Logo -->
                                <div class="flex-shrink-0 flex items-center">
                                    <a href="/dashboard">
                                        <jet-application-mark
                                            class="block h-9 w-auto"
                                        />
                                    </a>
                                </div>

                                <!-- Navigation Links -->
                                <div
                                    class="hidden space-x-8 sm:-my-px sm:ml-10 sm:flex"
                                >
                                    <!--                                <jet-nav-link href="/dashboard" :active="route().current() == 'dashboard'">-->
                                    <!--                                    Dashboard-->
                                    <!--                                </jet-nav-link>-->
                                </div>
                            </div>

                            <div class="hidden sm:flex sm:items-center sm:ml-6">
                                <phone-number-and-status />

                                <Link href="/messages/create" class="app-create-message-button-2 leading-5 whitespace-no-wrap inline-flex items-center">
                                    <span class="mr-1 leading-5">+</span>
                                    New Message
                                </Link>
                                <!-- My Account Dropdown -->
                                <div class="ml-3 relative">
                                    <jet-dropdown align="right" width="48">
                                        <template #trigger>
                                            <button
                                                class="flex text-sm border-2 border-avatar-bg rounded-full focus:outline-none focus:border-gray-300 transition duration-150 ease-in-out items-center text-gray-800 font-bold"
                                            >
                                                <img
                                                    class="h-7 w-7 rounded-full object-cover"
                                                    :src="
                                                        $page.props.auth.user
                                                            .profile_photo_url
                                                    "
                                                    :alt="$page.props.auth.user.name"
                                                />
                                                <p class="pl-2 pr-3 whitespace-no-wrap">My Account </p>
                                            </button>
                                        </template>

                                        <template #content>
                                            <!-- Account Management -->
                                            <div
                                                class="block px-4 py-2 text-xs text-gray-400"
                                            >
                                                Manage Account
                                            </div>

                                            <jet-dropdown-link
                                                href="/user/profile"
                                            >
                                                Profile
                                            </jet-dropdown-link>
                                            <jet-dropdown-link
                                                href="/user/settings"
                                            >
                                                Settings
                                            </jet-dropdown-link>
                                            <jet-dropdown-link
                                                v-if="$page.props.is_admin"
                                                href="/team"
                                            >
                                                Team Management
                                            </jet-dropdown-link>
                                            <template v-if="false && !$page.props.auth.user.organization.a2p_verified && $page.props.auth.user.organization.has_active_subscription">
                                                <jet-dropdown-link href="/verified/start" v-if="!$page.props.auth.user.organization.a2p_submitted">
                                                    Get Verified
                                                </jet-dropdown-link>
                                                <jet-dropdown-link href="/verified/start" v-else>
                                                    <font-awesome-icon
                                                        class="text-green-500"
                                                        :icon="['far', 'check-circle']"
                                                        v-if="$page.props.auth.user.organization.a2p_verified"
                                                    ></font-awesome-icon>
                                                    Verified Sender
                                                </jet-dropdown-link>

                                            </template>

                                            <a
                                                href="/user/subscribe"
                                                class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
                                                v-if="
                                                    $page.props.is_admin &&
                                                    !$page.props.auth.user
                                                        .organization
                                                        .has_active_subscription
                                                "
                                            >
                                                Upgrade Account
                                            </a>
                                            <a
                                                href="/user/upgrade"
                                                class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
                                                v-if="
                                                    $page.props.is_admin &&
                                                    $page.props.auth.user
                                                        .organization
                                                        .has_active_subscription
                                                "
                                            >
                                                Upgrade Account
                                            </a>

                                            <a
                                                :href="route('my.subscription')"
                                                class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
                                                v-if="
                                                    $page.props.is_admin &&
                                                    $page.props.auth.user
                                                        .organization
                                                        .has_active_subscription
                                                "
                                            >
                                                My Subscription
                                            </a>

                                            <jet-dropdown-link
                                                href="/user/api-tokens"
                                                v-if="
                                                    $page.props.jetstream
                                                        .hasApiFeatures
                                                "
                                            >
                                                API Tokens
                                            </jet-dropdown-link>

                                            <div
                                                class="border-t border-gray-100"
                                            ></div>

                                            <!-- Team Management -->
                                            <template
                                                v-if="
                                                    $page.props.jetstream
                                                        .hasTeamFeatures
                                                "
                                            >
                                                <div
                                                    class="block px-4 py-2 text-xs text-gray-400"
                                                >
                                                    Manage Team
                                                </div>

                                                <!-- Team Settings -->
                                                <jet-dropdown-link
                                                    :href="
                                                        '/teams/' +
                                                            $page.props.auth.user
                                                                .current_team.id
                                                    "
                                                >
                                                    Team Settings
                                                </jet-dropdown-link>

                                                <jet-dropdown-link
                                                    href="/teams/create"
                                                    v-if="
                                                        $page.props.jetstream
                                                            .canCreateTeams
                                                    "
                                                >
                                                    Create New Team
                                                </jet-dropdown-link>

                                                <div
                                                    class="border-t border-gray-100"
                                                ></div>

                                                <!-- Team Switcher -->
                                                <div
                                                    class="block px-4 py-2 text-xs text-gray-400"
                                                >
                                                    Switch Teams
                                                </div>

                                                <template
                                                    v-for="team in $page.props
                                                        .user.all_teams"
                                                >
                                                    <form
                                                        @submit.prevent="
                                                            switchToTeam(team)
                                                        "
                                                    >
                                                        <jet-dropdown-link
                                                            as="button"
                                                        >
                                                            <div
                                                                class="flex items-center"
                                                            >
                                                                <svg
                                                                    v-if="
                                                                        team.id ==
                                                                            $page
                                                                                .user
                                                                                .current_team_id
                                                                    "
                                                                    class="mr-2 h-5 w-5 text-green-400"
                                                                    fill="none"
                                                                    stroke-linecap="round"
                                                                    stroke-linejoin="round"
                                                                    stroke-width="2"
                                                                    stroke="currentColor"
                                                                    viewBox="0 0 24 24"
                                                                >
                                                                    <path
                                                                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                                                    ></path>
                                                                </svg>
                                                                <div>
                                                                    {{
                                                                        team.name
                                                                    }}
                                                                </div>
                                                            </div>
                                                        </jet-dropdown-link>
                                                    </form>
                                                </template>

                                                <div
                                                    class="border-t border-gray-100"
                                                ></div>
                                            </template>

                                            <!-- Authentication -->
                                            <form @submit.prevent="logout">
                                                <jet-dropdown-link as="button">
                                                    Logout
                                                </jet-dropdown-link>
                                            </form>
                                        </template>
                                    </jet-dropdown>
                                </div>
                            </div>

                            <!-- Hamburger -->
                            <div class="-mr-2 flex items-center sm:hidden">
                                <button
                                    @click="
                                        showingNavigationDropdown = !showingNavigationDropdown
                                    "
                                    class="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500 transition duration-150 ease-in-out"
                                >
                                    <svg
                                        class="h-6 w-6"
                                        stroke="currentColor"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            :class="{
                                                hidden: showingNavigationDropdown,
                                                'inline-flex': !showingNavigationDropdown
                                            }"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M4 6h16M4 12h16M4 18h16"
                                        />
                                        <path
                                            :class="{
                                                hidden: !showingNavigationDropdown,
                                                'inline-flex': showingNavigationDropdown
                                            }"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M6 18L18 6M6 6l12 12"
                                        />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>

                    <NavigationMobileMenu
                        v-show="showingNavigationDropdown"
                        :page="$page"
                    />
                </nav>

                <!-- Page Heading -->
                <header class="">
                    <div class="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
                        <slot name="header"></slot>
                    </div>
                </header>

                <!-- Page Content -->
                <main>
                    <slot></slot>
                </main>
            </div>
        </div>
    </div>
</template>

<script>
import JetApplicationLogo from "../Jetstream/ApplicationLogo";
import JetApplicationMark from "../Jetstream/ApplicationMark";
import JetDropdown from "../Jetstream/Dropdown";
import JetDropdownLink from "../Jetstream/DropdownLink";
import JetNavLink from "../Jetstream/NavLink";
import JetResponsiveNavLink from "../Jetstream/ResponsiveNavLink";
import axios from "axios";
import CreateMessageModal from '../components/CreateMessageModal';
import NavigationMobileMenu from "../components/Navigation/NavigationMobileMenu.vue";
import PhoneNumberAndStatus from "@/components/PhoneNumberAndStatus";
import { useGlobalStore } from '@/Stores/global';
import {mapWritableState, mapActions, mapState} from 'pinia';
import InboxIcon from '../components/InboxIcon';

export default {
    components: {
        JetApplicationLogo,
        JetApplicationMark,
        JetDropdown,
        JetDropdownLink,
        JetNavLink,
        JetResponsiveNavLink,
        CreateMessageModal,
        InboxIcon,
        NavigationMobileMenu,
        PhoneNumberAndStatus,
    },

    data() {
        return {
            showingNavigationDropdown: false,
        }
    },
    methods: {
        switchToTeam(team) {
            this.$inertia.put(
                "/current-team",
                {
                    team_id: team.id
                },
                {
                    preserveState: false
                }
            );
        },
        logout() {
            axios.post("/logout").then(response => {
                window.location = "/";
            });
        },
        showIntercom() {
            window.Intercom('showNewMessage');
        }
    },
    computed: {
        ...mapWritableState(useGlobalStore, {
            storePage: '$page',
        }),
        path() {
            return window.location.pathname;
        },
        showVerifiedWarningBanner() {
            if (!this.$page.props.auth.user) { return false; }
            if (!this.$page.props.subscribed) { return false; }
            if (this.$page.props.auth.user.organization.a2p_verified) { return false; }
            if (this.$page.props.submitted_a2p) { return false }
            if (this.$page.props.paused) { return false; }
            if (window.location.href.includes('/verified')) { return false; }
            if (window.location.href.includes('select-number')) { return false; }
            if (window.location.href.includes('user')) { return false; }
            return true;
        },
        showAccountPausedWarning() {
            if (!this.$page.props.paused) { return false; }
            if (window.location.href.includes('/user')) { return false; }
            return true;
        },
    },

    created() {
        this.storePage = this.$page;
    },
    mounted() {
        
    },
    
    watch: {
        '$page.props.flash.success': {
            handler(newValue) {
                if (newValue) {
                    this.$toasted.show(newValue, {
                        type: 'success',
                        duration: 4000
                    });
                }
            },
            immediate: true
        },
        '$page.props.flash.error': {
            handler(newValue) {
                if (newValue) {
                    this.$toasted.show(newValue, {
                        type: 'error',
                        duration: 4000
                    });
                }
            },
            immediate: true
        }
    }

};
</script>

<style scoped>
.top-bar-color {
    background: linear-gradient(
        90deg,
        rgba(255, 142, 3, 1) 10%,
        rgba(241, 207, 16, 1) 30%,
        rgba(170, 16, 241, 1) 50%,
        rgba(46, 212, 122, 1) 70%,
        rgba(16, 156, 241, 1) 90%
    );
    height: 7px;
    width: 100%;
}

.app-create-message-button {
    @apply items-center p-3 mt-10 text-sm font-medium leading-5 text-gray-700 w-full;
    @apply transition duration-150 ease-in-out;
    @apply block border-gray-500 rounded;
    border-width: 1px;
}
.app-create-message-button:hover {
    @apply border-gray-900 text-gray-900;
}
.app-create-message-button:focus {
    @apply outline-none text-gray-700;
}
.app-create-message-button-2 {
    @apply py-1 px-3 text-sm;
    border-radius: 1rem;
    /*
    @apply text-white;
    background: rgba(255,142,3,1);
    */

    /* border-width: 1px; */
    @apply bg-gray-200;
}
.app-create-message-button-2:focus {
    @apply outline-none;
}

.beta-tag {
    background-color: #A0AEC0;
    border-radius: 10px;
}
.beta-tag.active {
    background-color: #2ED47A;
}

.zapier-svg {
    height: 20px;
    width: 20px;
}

.w-64{
  width: 225px !important;
}

</style>
